import React from "react"

import Layout from "@/components/Layout"
import Seo from "@/components/Seo"

export default () => (
  <Layout>
    <Seo title='Отрицательные индексы'/>
    <article>
      <h1>Отрицательные индексы</h1>

      <time dateTime="2016-03-17">17 марта 2016 г.</time>

      <h2>Что не так?</h2>

      <pre>
<code>let arr = [];
arr[-1] = 'foo'; // В массив записывается элемент с отрицательным индексом
arr; // [] — после этого массив выглядит пустым
arr[-1]; // foo — но это не так</code>
</pre>

      <p>В массив можно записать элемент с отрицательным индексом. При этом его не видно при вызове массива. Но он
        есть. Как суслик.</p>

      <blockquote>
<pre>
… Видишь суслика?
— Нет.
— И я не вижу. А он есть!
</pre>
        <cite>© <a target="_blank" rel="nofollow noopener noreferrer"
                   href="https://ru.wikiquote.org/wiki/%D0%94%D0%9C%D0%91_%28%D1%84%D0%B8%D0%BB%D1%8C%D0%BC%29">прапорщик
          Казаков, фильм «ДМБ»</a></cite>
      </blockquote>

      <h2>Почему так?</h2>

      <p>Несмотря на то, что индекс — это число, записывать элементы массива можно только по натуральным индексам.
        Попытка записать элемент на какой-либо другой индекс (например, объект, дробное число или отрицательное
        число) вызовёт преобразование индекса к строке и запись не <strong>элемента массива</strong>, а <strong>свойства
          массива</strong> по ключу.</p>

      <p>Поэтому запись проходит успешно, но записывается не элемент, а свойство.</p>

      <h2>Что же делать?</h2>

      <p>
        <del>Молиться, поститься и слушать радио «Радонеж».</del>
        Да особо ничего. Просто при странных действиях не нужно ожидать адекватных результатов.
      </p>

    </article>
  </Layout>
)
